import script from "./MainComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MainComponent.vue?vue&type=script&setup=true&lang=js"

import "./MainComponent.vue?vue&type=style&index=0&id=22d08338&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22d08338"]])

export default __exports__